import { useActivePropertyStore } from '@/stores/active-property-store';
import { useUserProfileStore } from '@/stores/user-profile-store';
import { UpsellSheet } from '@/components/common/UpsellSheet';
import { UPSELL_COPY } from '@/constants/upsell-copy';
import { useNavigate } from 'react-router-dom';

export function PatternsPage() {
  const { activePropertyId } = useActivePropertyStore();
  const isPro = useUserProfileStore((s) => s.isPro);
  const navigate = useNavigate();

  if (!isPro()) {
    return (
      <UpsellSheet
        featureName={UPSELL_COPY.pattern_surfacing.featureName}
        description={UPSELL_COPY.pattern_surfacing.description}
        featureGate="pattern_surfacing"
        onDismiss={() => navigate(-1)}
      />
    );
  }

  if (!activePropertyId) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 py-20 px-6 text-center" data-testid="patterns-page-no-property">
        <p className="text-body-sm text-[var(--color-text-placeholder)]">Select a property on the Map tab to view patterns.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4" data-testid="patterns-page">
      <h1 className="font-display text-display-lg text-[var(--color-text-primary)]">Patterns</h1>
      <p className="text-body-sm text-[var(--color-text-placeholder)]">
        Pattern analysis for your active property will appear here.
      </p>
    </div>
  );
}
